import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { MatSidenav } from "@angular/material/sidenav";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LayoutService } from "../../../@core/utils";

@Component({
    selector: "ngx-one-column-layout",
    styleUrls: ["./one-column.layout.scss"],
    template: `
    <div class="evta-layout">
      <mat-toolbar class="evta-header">
        <ngx-header></ngx-header>
      </mat-toolbar>
      <mat-sidenav-container class="evta-sidenav-container">
        <mat-sidenav
          #sidenav
          [mode]="isMobile ? 'over' : 'side'"
          [opened]="!isMobile"
          class="evta-sidebar">
          <ng-content select="[sidebar]"></ng-content>
        </mat-sidenav>
        <mat-sidenav-content class="evta-content">
          <ng-content select="router-outlet"></ng-content>
          <footer class="evta-footer">
            <ngx-footer></ngx-footer>
          </footer>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  `,
    standalone: false
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy {
  @ViewChild("sidenav") sidenav!: MatSidenav;

  isMobile = false;
  private destroy$ = new Subject<void>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private layoutService: LayoutService,
  ) {}

  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    this.layoutService
      .onSidebarToggle()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.sidenav.toggle();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
